import React from "react";

export default function ProgressRing({ pct = 0, size = 44, stroke = 4, color = "var(--arena-cyan)", children }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - Math.max(0, Math.min(1, pct / 100)));
  return (
    <div className="relative inline-grid place-items-center" style={{ width: size, height: size, color }}>
      <svg className="arena-ring absolute inset-0" width={size} height={size}>
        <circle cx={size / 2} cy={size / 2} r={r} className="arena-ring-track" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          className="arena-ring-fill"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeDasharray={c}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="relative text-[10px] font-bold tabular-nums">{children}</div>
    </div>
  );
}
